import { useState } from "react";
import { Container, Grid } from "@material-ui/core";
import HeaderClientes from "components/_refactor/headers/clients";
import FilterCard from "components/_refactor/filter-card";
import StructureFields from "components/_refactor/fields/structure";
import MonthYearField from "components/_refactor/fields/month-year";
import LoadingData from "components/Loading/LoadingData";
import SellerDialog from "./components/dialog-vendedores";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import TableGoals from "./components/table-goals";
import getMonthByNumber from "utils/get-month-by-number";

const MONTH_INDEX = new Date().getMonth() + 1;
const YEAR = new Date().getFullYear();

export default function MetasVendedores() {
  const [goals, setGoals] = useState([]);
  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState(false);
  const [month, setMonth] = useState({
    value: MONTH_INDEX,
    label: getMonthByNumber(MONTH_INDEX),
  });
  const [year, setYear] = useState({ value: YEAR, label: String(YEAR) });
  const [clearFilters, setClearFilters] = useState(false);
  const [searching, setSearching] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [goal, setGoal] = useState();

  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const snackbar = useSnackbar();

  const handleSearchGoals = async ({ page = 0, sizePerPage = 25 }) => {
    setSearching(true);
    try {
      const response = await Api.get(
        "goal-store",
        "goals",
        "?page=" +
          page +
          "&pageSize=" +
          sizePerPage +
          "&idGrupoEconomico=" +
          structureFilters?.idGrupoEconomico +
          "&idLoja=" +
          structureFilters?.idLojaUnica +
          "&mes=" +
          month.value +
          "&ano=" +
          year.value,
        true
      );

      const metasComDiasOffFormatado = (
        response?.Result?.ListMetasFaixas || []
      ).map((meta) => ({
        ...meta,
        ListVendedor: (meta.ListVendedor || []).map((vendedor) => ({
          ...vendedor,
          DiasOff: (vendedor.DiasOff || []).map((data) =>
            typeof data === "string" ? data.replace(/\//g, "-") : data
          ),
        })),
      }));
      setGoals(metasComDiasOffFormatado);
      setCurrentPage(response?.Result?.Pagina || 0);
      setTotalRegisters(response?.Result?.TotalRegistros || 0);
      setCurrentSizePerPage(sizePerPage);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar as metas: " + error.message, {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const handleSearch = () => {
    handleSearchGoals({ page: 0, sizePerPage: currentSizePerPage });
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setMonth("");
    setYear("");
  };

  return (
    <div>
      <HeaderClientes section="Metas por Vendedor" subsection="Metas" />
      <Container style={{ marginTop: "-4rem" }} maxWidth={false}>
        <Grid item xs={12}>
          <FilterCard
            handleSearch={handleSearch}
            disabled={
              searching ||
              !structureFilters.idGrupoEconomico ||
              !structureFilters.idLojaUnica ||
              !structureLoading
            }
            searching={searching}
            handleClearFilters={handleClearFilters}
          >
            <StructureFields
              onStructureFieldsChange={setStructureFilters}
              disableAll={searching}
              onStructureFieldsLoad={setStructureLoading}
              requiredFields={["economicGroup", "storeSingle"]}
              hideFields={["brand", "channel", "representative", "store"]}
              clearFilters={clearFilters}
              handleSearch={handleSearch}
              showSingleStore
            />
            <MonthYearField
              month={month}
              handleMonthChange={setMonth}
              year={year}
              handleYearChange={setYear}
              disabled={searching}
              required={false}
              direction="both"
              yearsCount={2}
            />
          </FilterCard>
        </Grid>

        <Grid item xs={12}>
          {searching ? (
            <LoadingData searching={searching} label="Buscando dados..." />
          ) : (
            <TableGoals
              data={goals}
              loading={searching}
              onAction={(action, row) => {
                if (action === "edit") {
                  setGoal(row);
                  setOpenDialog(true);
                }
                if (action === "create") {
                  setOpenDialog(true);
                }
              }}
              onResearch={handleSearchGoals}
              totalRegistros={totalRegisters}
              currentPage={currentPage}
              currentSizePerPage={currentSizePerPage}
              onTableChange={(type, { page, sizePerPage }) => {
                handleSearchGoals({ page: page - 1, sizePerPage });
              }}
            />
          )}
        </Grid>

        {openDialog && (
          <SellerDialog
            open={openDialog}
            onClose={() => {
              setOpenDialog(false);
              setGoal(null);
              handleSearch();
            }}
            goal={goal}
          />
        )}
      </Container>
    </div>
  );
}
